<template>
  <el-dialog title="一键控温" :visible.sync="$parent.dialogVisible" width="25%">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
    >
      <el-form-item label="设置温度" prop="tempValue">
        <el-input-number
          v-model="ruleForm.tempValue"
          :min="16"
          :max="35"
          label="温度"
          :precision="0"
        ></el-input-number>
      </el-form-item>
      <p class="tempControlDialogInfoWrap">
        <i class="el-icon-warning-outline"></i>
        <span>该功能仅支持已开启设备</span>
      </p>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="$parent.dialogVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="submitForm('ruleForm')"
        :loading="loading"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import api from "@/api";
export default {
  props: {
    treeActive: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      ruleForm: {
        tempValue: 26,
      },
      loading: false,
      rules: {
        tempValue: [
          { required: true, message: "请设置温度", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          let res = await api.ACRControlTemp({
            entityId: this.treeActive.id,
            type: "风机盘管",
            projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
              .projects[0].projectId,
            value: this.ruleForm.tempValue,
          });
          if (res?.data.code == 200) {
            this.$message.success("温度设置成功，已下发");
            this.$parent.dialogVisible = false;
          } else {
            this.loading = false;
            this.$message.error(res.codeMsg);
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tempControlDialogInfoWrap {
  color: red;
  font-size: 12px;
  @include setFlexStart;
  margin-left: 30px;
  i {
    margin: 2px 3px 0 0;
    // margin-right: 3px;
    font-size: 14px;
  }
}
</style>
